import './bookappointment.css';
import Modal from '../modal/Modal';
import BookingInfos from '../form/BookingInfos';

import { useRef } from 'react';

const CtaBtn = ({ name, handleModal, modalRef }) => {
  const ModalRef = useRef();
  return (
    <>
      <button
        className="btn text-center hover:scale-90 mobileBtn"
        onClick={() => ModalRef.current.openModal()}
      >
        {name}
      </button>
      <Modal ref={ModalRef}>
        <BookingInfos />
      </Modal>
    </>
  );
};

export default CtaBtn;
